'use client';

import type { ExperimentVersionType } from '../types/experimentValues';

export function useExperimentValue(): ExperimentVersionType {
    return 'fullsolution';
}
